import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';

import { ResolutionTimeRoutesApplication } from '../../constants';

function setupResolutionTime(): void {
  applicationModuleRegistry.register({
    closeable: true,
    id: 'resolution-time',
    entry: 'resolution-time',
    name: 'kpi.resolution-time',
    route: ResolutionTimeRoutesApplication.RESOLUTION_TIME,
  });
}

export {
  setupResolutionTime,
};
